
import { supabase } from "@/integrations/supabase/client";

export const fetchDocumentPermissions = async (documentId: string): Promise<any[]> => {
  try {
    // First get the permissions
    const { data: permissions, error } = await supabase
      .from('document_permissions')
      .select(`
        id,
        document_id,
        user_id,
        permission_type,
        created_at
      `)
      .eq('document_id', documentId);

    if (error) throw error;
    
    if (!permissions || permissions.length === 0) {
      return [];
    }

    // Get user IDs to fetch profile information
    const userIds = permissions.map(p => p.user_id);
    
    // Fetch profiles separately to avoid join issues
    const { data: profiles, error: profilesError } = await supabase
      .from('profiles')
      .select('id, first_name, last_name, email')
      .in('id', userIds);

    if (profilesError) {
      // If profiles query fails, return permissions without user info
      return permissions.map(perm => ({
        ...perm,
        user: null
      }));
    }

    // Combine permissions with profile data
    return permissions.map(perm => ({
      ...perm,
      user: profiles?.find(profile => profile.id === perm.user_id) || null
    }));
  } catch (error) {
    throw error;
  }
};

export const addDocumentPermission = async (
  documentId: string, 
  userId: string, 
  permissionType: string
): Promise<any> => {
  try {
    const { data, error } = await supabase
      .from('document_permissions')
      .insert({
        document_id: documentId,
        user_id: userId,
        permission_type: permissionType
      })
      .select();

    if (error) throw error;
    return data;
  } catch (error) {
    throw error;
  }
};

export const removeDocumentPermission = async (permissionId: string): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from('document_permissions')
      .delete()
      .eq('id', permissionId);

    if (error) throw error;
    return true;
  } catch (error) {
    throw error;
  }
};
